import React from "react";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";
import {Typography} from "../../../../designSystem/components/Typography";
import {InformationTable} from "../InformationTable";
import {InformationRow} from "../InformationRow";
import {ICase} from "../../../../types/Case";

interface ApplicationPatientInformationViewProps {
  caseData: ICase;
}

export const ApplicationPatientInformationView = ({
  caseData
}: ApplicationPatientInformationViewProps) => (
  <DashboardCard>
    <Typography variant="subtitle">
      個案資訊
    </Typography>
    <InformationTable>
      <InformationRow title="姓名" value={caseData.patientName}/>
      <InformationRow title="性別" value={caseData.patientGender}/>
      <InformationRow title="身分證" value={caseData.patientId}/>
      <InformationRow title="生日" value={caseData.patientBirthday}/>
      <InformationRow title="住址" value={caseData.patientAddress}/>
      <InformationRow title="是否有管路" value={caseData.patientHasTube}/>
      <InformationRow title="主要照顧者姓名" value={caseData.primaryCaregiverName}/>
      <InformationRow title="與個案關係" value={caseData.relationshipWithPatient}/>
      <InformationRow title="個案/家屬電話" value={caseData.contactNumber}/>
      <InformationRow title="目前接受在宅照服項目" value={caseData.currentHomeCareService}/>
    </InformationTable>
  </DashboardCard>
)
